import {Form, Formik} from 'formik';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import * as Yup from 'yup';

import DotsLoading from '../../../../components/dotsLoading';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import {useAuth} from '../../../../context/authContext';
import FloatingOnlySelectBottomSheet from '../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import PrimaryCardAR from '../../../../module/newShop/advertisementRegisteration/primaryCardAR';
import {
  usePatchEmployeeAdvertisement,
  usePatchEmployeeRequirements,
  usePatchFarmAdvertisement,
  usePatchFarmRequirement,
  usePatchFertilizerAdvertisement,
  usePatchFertilizerRequirement,
  usePatchLabRequirement,
  usePatchMachineryAdvertisement,
  usePatchPesticideAdvertisement,
  usePatchSeedAdvertisement,
  usePatchSeedRequirement,
  usePatchToolRequirement,
} from '../../../../services/hookService';
import useGetAdvertisementDetail from '../../../../services/hookService/getAdvertisementRequirementDetail/useGetAdvertisementRequirementDetail';
import useGetInputUnits from '../../../../services/hookService/getInputUnits/useGetInputUnits';
import useGetListBrand from '../../../../services/hookService/getListBrand/useGetListBrand';
import {usePatchMachineryRequirement} from '../../../../services/hookService/patchMachineryRequirements/usePatchMachineryRequirements';
import {usePatchPesticideRequirement} from '../../../../services/hookService/patchPesticideRequirement/usePatchPesticideRequirement';
import {usePatchToolAdvertisement} from '../../../../services/hookService/PatchToolAdvertisement/usePatchToolAdvertisement';
import {RootState} from '../../../../store/redux';
import {clearAllData} from '../../../../store/redux/addPictureAdvertisment';
import {
  addOptionalFormData,
  addRegisterAdvertisement,
  resetAllAdvertisementData,
} from '../../../../store/redux/advertisementRegisteration';
import {ScrollToError} from '../../../../utilities/helper/scrollToError/ScrollToError';
import {
  convertAdvertisementType,
  getAmountUnits,
  getPriceUnits,
} from '../../../../utilities/helper/unitGenerator';
import {AdvertisementType} from '../../../../utilities/helper/unitGenerator/unit.types';
import {GroupNameToInputName} from '../../advertisementList/utils';
import {
  adsTypes,
  emptyQuantityPack,
  validateExemple,
  validateInitialValue,
} from '../../advertisementRegisteration/constants';
import AdvertisementTypesBottomSheet from '../../advertisementRegisteration/elements/bottomsheetList/advertisementTypesBottomSheet';
import InputListBottomsheet from '../../advertisementRegisteration/elements/bottomsheetList/inputListBottomsheet';
import RentBottomsheet from '../../advertisementRegisteration/elements/bottomsheetList/rentBottomSheet';
import ServiceBottomsheet from '../../advertisementRegisteration/elements/bottomsheetList/serviceBottomSheet';
import Buy from '../../advertisementRegisteration/elements/buy';
import EmptyFarmModal from '../../advertisementRegisteration/elements/modal/emptyFarmModal';
import SuccessRegisterModal from '../../advertisementRegisteration/elements/modal/successRegisterModal';
import Rent from '../../advertisementRegisteration/elements/rent';
import Sale from '../../advertisementRegisteration/elements/sale';
import Service from '../../advertisementRegisteration/elements/service';
import {IGeneralType, ISrs_type} from '../../advertisementRegisteration/types';
import useCreateObj from '../hooks/useCreateObj';
import {StoreAccountPlanType} from '../../../../global/constants/storeType';

const EditAdds = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locational = useLocation();
  const {guid, advertisement_type} = useParams();
  const state = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const imagesState = useSelector(
    (state: RootState) => state.addPictureAdvertisement,
  );

  const allReduxImages = [
    ...(imagesState?.cropedImage || []),
    ...(imagesState?.adminImages || []),
  ];

  const {data: brandList, isLoading: brandListLoading} = useGetListBrand();

  const {advertisementDetail, isLoading} = useGetAdvertisementDetail({
    guid: guid as string,
    advertisement_type: advertisement_type as string,
    type: locational?.state?.type as string,
  });

  const selectedBrand = brandList?.find(item =>
    //@ts-ignore
    item?.sub_brand?.find(sub => sub.id === advertisementDetail?.sub_brand),
  );

  useEffect(() => {
    if (selectedBrand) {
      const selectedSubBrand = selectedBrand.sub_brand?.find(
        //@ts-ignore
        sub => sub.id === advertisementDetail?.sub_brand,
      );
      if (selectedSubBrand) {
        dispatch(
          addRegisterAdvertisement({
            ...state,
            //@ts-ignore
            sub_brand_data: selectedSubBrand,
          }),
        );
      }
    }
  }, [selectedBrand, advertisementDetail, dispatch, state]);

  const handleKind = () => {
    if (state.srs_type?.type === 'sell') {
      return 'give';
    } else if (state.srs_type?.type === 'buy') {
      return 'catch';
    } else if (state.srs_type?.type === 'service') {
      if (state.serviceBottomSheetData === 'providedService') {
        return 'give';
      } else {
        return 'catch';
      }
    } else if (state.srs_type?.type === 'rent') {
      if (state.rentBottomSheetData === 'providedRent') {
        return 'give';
      } else {
        return 'catch';
      }
    }
  };

  const payload = {
    input_guid: state.input?.guid,
    operation_type: state.srs_type?.type,
    kind: handleKind(),
  };

  const {unitData, unitsIsLoading} = useGetInputUnits(payload);

  const subType = state?.rentBottomSheetData ?? state?.serviceBottomSheetData;

  useCreateObj(
    locational?.state?.type,
    advertisementDetail as IAdvertisementDetail,
    getAmountUnits(
      convertAdvertisementType(
        state?.srs_type?.type,
        subType as AdvertisementType,
      )!,
      state?.input_group?.code as number,
      state?.input?.code as number,
      state.sub_input?.code as number,
    ),
    getPriceUnits(
      convertAdvertisementType(
        state?.srs_type?.type,
        subType as AdvertisementType,
      )!,
      state?.input_group?.code as number,
      state?.input?.code,
    ),
  );

  const {cropedImage} = useSelector(
    (state: RootState) => state.addPictureAdvertisement,
  );

  const {supplierProfile} = useAuth();

  const [openInputListBottomSheet, setOpenInputListBottomSheet] =
    useState<boolean>(false);
  const [openRentBottomsheet, setOpenRentBottomsheet] =
    useState<boolean>(false);
  const [openServiceBottomsheet, setOpenServiceBottomsheet] =
    useState<boolean>(false);
  const [
    openAdvertisementTypeBottomSheet,
    setOpenAdvertisementTypeBottomSheet,
  ] = useState<boolean>(false);
  const [isSuccessModal, setIsSuccessModal] = useState<boolean>(false);
  const [isEmptyFarmModal, setIsEmptyFarmModal] = useState<boolean>(false);

  const [modalText, setModalText] = useState<string>('');

  const clearReduxAdvertisement = () => {
    dispatch(addOptionalFormData(''));
    dispatch(clearAllData());
  };
  const HandleAfterSuccess = (response?: IAddedAdvertisementResponse) => {
    clearReduxAdvertisement();
    setIsSuccessModal(true);
    navigate('/home', {state: response});
  };

  useEffect(() => {
    if (locational?.state?.type === 'requirement') {
      if (advertisementDetail?.brs_type === 'rent') {
        dispatch(
          addRegisterAdvertisement({
            ...state,
            rentBottomSheetData: 'wantedRent',
          }),
        );
      } else if (advertisementDetail?.brs_type === 'service') {
        dispatch(
          addRegisterAdvertisement({
            ...state,
            serviceBottomSheetData: 'wantedService',
          }),
        );
      }
    } else {
      if (advertisementDetail?.srs_type === 'rent') {
        dispatch(
          addRegisterAdvertisement({
            ...state,
            rentBottomSheetData: 'providedRent',
          }),
        );
      } else if (advertisementDetail?.srs_type === 'service') {
        dispatch(
          addRegisterAdvertisement({
            ...state,
            serviceBottomSheetData: 'providedService',
          }),
        );
      }
    }
  }, [
    advertisementDetail,
    locational?.state?.type,
    advertisementDetail?.srs_type,
    advertisementDetail?.brs_type,
    advertisementDetail?.input_group?.code,
  ]);

  //* ------------------------------------------------------------------- PATCH FERTILIZER

  const {
    mutate: mutateFertilizerAdvertisement,
    isLoading: FertilizerIsLoading,
  } = usePatchFertilizerAdvertisement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });

  //* ------------------------------------------------------------------- PATCH PESTICIDE

  const {mutate: mutatePesticideAdvertisement, isLoading: PesticideIsLoading} =
    usePatchPesticideAdvertisement({
      guid,
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });

  //* ------------------------------------------------------------------- PATCH SEED

  const {mutate: mutateSeedAdvertisement} = usePatchSeedAdvertisement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });

  //* ------------------------------------------------------------------- PATCH MACHINERY

  const {mutate: mutateMachineryAdvertisement} = usePatchMachineryAdvertisement(
    {
      guid,
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    },
  );

  //* ------------------------------------------------------------------- PATCH TOOLS

  const {mutate: mutateToolAdvertisement} = usePatchToolAdvertisement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });

  const {mutate: mutateEmployeeAdvertisement} = usePatchEmployeeAdvertisement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutateFarmAdvertisement} = usePatchFarmAdvertisement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutateFertilizerRequirement} = usePatchFertilizerRequirement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutatePesticideRequirement} = usePatchPesticideRequirement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutateSeedRequirement} = usePatchSeedRequirement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });

  // ---------------------------------- REQUIREMENT ---------------------------------- //

  const {mutate: mutateMachineryRequirement} = usePatchMachineryRequirement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutateToolRequirement} = usePatchToolRequirement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutateEmployeeRequirement} = usePatchEmployeeRequirements({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutateFarmRequirement} = usePatchFarmRequirement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutateLabRequirement} = usePatchLabRequirement({
    guid,
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });

  const dynamicLoadingState: Record<string, boolean> = {
    Fertilizer: FertilizerIsLoading,
    Pesticide: PesticideIsLoading,
  };

  const actionFn = (props: IGeneralType) => {
    if (state?.input_group) {
      if (state?.srs_type.type === 'sale') {
        if (state?.input_group.type === 'fertilizer') {
          return mutateFertilizerAdvertisement(
            {...props},
            {onSuccess: () => HandleAfterSuccess()},
          );
        } else if (state?.input_group.type === 'pesticide') {
          return mutatePesticideAdvertisement(
            {...props},
            {onSuccess: () => HandleAfterSuccess()},
          );
        } else if (state?.input_group.type === 'seed') {
          return mutateSeedAdvertisement({...props});
        } else if (state?.input_group.type === 'machinery') {
          return mutateMachineryAdvertisement({...props});
        } else if (state?.input_group.type === 'tool') {
          return mutateToolAdvertisement({...props});
        } else if (state?.input_group.type === 'employee') {
          return mutateEmployeeAdvertisement({...props});
        } else if (state?.input_group.type === 'farm') {
          return mutateFarmAdvertisement({...props});
        }
      }
      if (state?.srs_type.type === 'buy') {
        if (state?.input_group.type === 'fertilizer') {
          return mutateFertilizerRequirement({...props});
        } else if (state?.input_group.type === 'pesticide') {
          return mutatePesticideRequirement({...props});
        } else if (state?.input_group.type === 'seed') {
          return mutateSeedRequirement({...props});
        } else if (state?.input_group.type === 'machinery') {
          return mutateMachineryRequirement({...props});
        } else if (state?.input_group.type === 'tool') {
          return mutateToolRequirement({...props});
        } else if (state?.input_group.type === 'employee') {
          return mutateEmployeeRequirement({...props});
        } else if (state?.input_group.type === 'farm') {
          return mutateFarmRequirement({...props});
        }
      }
      if (
        state?.srs_type.type === 'service' &&
        state?.serviceBottomSheetData === 'providedService'
      ) {
        if (state?.input_group.type === 'machinery') {
          return mutateMachineryAdvertisement({...props});
        } else if (state?.input_group.type === 'employee') {
          return mutateEmployeeAdvertisement({...props});
        }
      }
      if (
        state?.srs_type.type === 'service' &&
        state?.serviceBottomSheetData === 'wantedService'
      ) {
        if (state?.input_group.type === 'machinery') {
          return mutateMachineryRequirement({...props});
        } else if (state?.input_group.type === 'employee') {
          return mutateEmployeeRequirement({...props});
        } else if (state?.input_group.type === 'lab') {
          return mutateLabRequirement({...props});
        }
      }
      if (
        state?.srs_type.type === 'rent' &&
        state?.rentBottomSheetData === 'providedRent'
      ) {
        if (state?.input_group.type === 'machinery') {
          return mutateMachineryAdvertisement({...props});
        } else if (state?.input_group.type === 'farm') {
          return mutateFarmAdvertisement({...props});
        }
      }
      if (
        state?.srs_type.type === 'rent' &&
        state?.rentBottomSheetData === 'wantedRent'
      ) {
        if (state?.input_group.type === 'machinery') {
          return mutateMachineryRequirement({...props});
        } else if (state?.input_group.type === 'farm') {
          return mutateFarmRequirement({...props});
        }
      }
    }
  };

  const handleSchema = () => {
    if (state?.srs_type && state?.input_group && state?.input) {
      if (state?.srs_type?.type === 'rent' && state?.rentBottomSheetData) {
        return Yup.object().shape({
          ...validateExemple(state?.input?.title)[
            state?.rentBottomSheetData +
              state?.input_group?.code +
              state?.input?.code
          ],
        });
      } else if (
        state?.srs_type?.type === 'service' &&
        state?.serviceBottomSheetData
      ) {
        return Yup.object().shape({
          ...validateExemple(state?.input?.title)[
            state?.serviceBottomSheetData +
              state?.input_group?.code +
              state?.input?.code
          ],
        });
      } else if (state?.input_group?.code === 17) {
        return Yup.object().shape({
          ...validateExemple(state?.input?.title)[
            state?.srs_type?.type +
              state?.input_group?.code +
              state?.input?.code
          ],
        });
      } else {
        return Yup.object().shape({
          ...validateExemple(
            state?.input?.title,
            state.input_group.type &&
              GroupNameToInputName[state.input_group.type],
          )[state?.srs_type?.type + state?.input_group?.code],
        });
      }
    } else {
      return Yup.object().shape({});
    }
  };

  const handleInitialValue = () => {
    const inputValueUnits = getAmountUnits(
      convertAdvertisementType(
        state?.srs_type?.type,
        subType as AdvertisementType,
      )!,
      state?.input_group?.code as number,
      state?.input?.code as number,
      state.sub_input?.code as number,
    );
    const inputPriceUnits = getPriceUnits(
      convertAdvertisementType(
        state?.srs_type?.type,
        subType as AdvertisementType,
      )!,
      state?.input_group?.code as number,
      state?.input?.code,
    );

    if (state?.srs_type && state?.input_group && state?.input) {
      if (state?.srs_type?.type === 'rent' && state?.rentBottomSheetData) {
        return validateInitialValue(inputValueUnits, inputPriceUnits)[
          state?.rentBottomSheetData +
            state?.input_group?.code +
            state?.input?.code
        ];
      } else if (
        state?.srs_type?.type === 'service' &&
        state?.serviceBottomSheetData
      ) {
        return validateInitialValue(inputValueUnits, inputPriceUnits)[
          state?.serviceBottomSheetData +
            state?.input_group?.code +
            state?.input?.code
        ];
      } else if (state?.input_group?.code === 17) {
        return validateInitialValue(inputValueUnits, inputPriceUnits)[
          state?.srs_type?.type + state?.input_group?.code + state?.input?.code
        ];
      } else {
        return validateInitialValue(inputValueUnits, inputPriceUnits)[
          state?.srs_type?.type + state?.input_group?.code
        ];
      }
    } else {
      return Yup.object().shape({});
    }
  };

  if (unitsIsLoading) {
    return (
      <div className="flex flex-col justify-between items-center h-full">
        <CustomHeader title="ثبت آگهی" backRoute="/home" />
        <DotsLoading />
        <div className="w-full">
          <MainFooter />
        </div>
      </div>
    );
  }

  const handleBack = () => {
    navigate(-1);
    clearReduxAdvertisement();
  };
  const isLab = Boolean(supplierProfile?.lab);
  const storePlanType =
    (isLab ? 120 : supplierProfile?.store?.store_type?.code) ??
    StoreAccountPlanType.NoStore;
  return (
    <div className="flex flex-col h-full">
      <CustomHeader
        preIcon="icon-nameArrow---Right"
        title="ویرایش آگهی"
        isActiveRightIcon={true}
        onClick={handleBack}
      />
      {advertisementDetail?.input_group?.code && !isLoading ? (
        <Formik
          initialValues={{
            ...handleInitialValue(),
            ...(state.formData && JSON.parse(state.formData)),
            sub_input: {
              title: state?.sub_input?.title,
              guid: state?.sub_input?.guid,
            },
            location: {
              lat: supplierProfile?.latlong[0],
              lng: supplierProfile?.latlong[1],
            },
            hasImages:
              allReduxImages.length || allReduxImages.some(img => img.flag)
                ? true
                : false,
            selectedMainImg:
              allReduxImages?.find(img => img.flag)?.id ??
              allReduxImages[0]?.id ??
              null,
            ad_price: state?.price,
            price_on_call: state?.price_on_call,
            available_quantity: state?.available_quantity,
            min_sell_quantity: state?.min_sell_quantity,
            title: state?.title,
            description: state?.description || '',
            combinations: state?.combinations || '',
            application_method: state?.application_method || '',
            quantity_pack_unit:
              state?.quantity_pack_unit ??
              handleInitialValue().quantity_pack_unit ??
              emptyQuantityPack.quantity_pack_unit,
            quantity_pack:
              state?.quantity_pack ??
              handleInitialValue().quantity_pack ??
              emptyQuantityPack.quantity_pack,
          }}
          enableReinitialize
          validationSchema={handleSchema()}
          onSubmit={(values, {resetForm}) => {
            const payload = {
              ad_type: state?.ad_type?.value,
              srs_type: state?.srs_type,
              ...(state?.input_group?.code === 17 &&
                state?.input?.code === 11 && {type: 'dry_land'}),
              ...(state?.input_group?.code === 17 &&
                state?.input?.code === 13 && {type: 'irrigated_land'}),
              is_change_title: state?.is_change_title,
              title: state?.title || '',
              description: state?.description || '',
              ad_price: state?.price || '',
              price_on_call: state.price_on_call,
              ...(state?.discount_amount &&
                state?.discount_amount !== null &&
                state?.discount_amount !== undefined && {
                  discount_amount: state?.discount_amount,
                }), // Strict check
              ...(state?.optionalFormData
                ? JSON.parse(state.optionalFormData)
                : {}),
              ...(state?.formData ? JSON.parse(state.formData) : {}),
              images: cropedImage?.map(item => item.id) || undefined,
              selectedMainImg: values.selectedMainImg,
              main_image:
                cropedImage &&
                cropedImage?.filter(item => item.flag === true)?.length > 0
                  ? cropedImage?.filter(item => item.flag === true)[0].id
                  : undefined,
            };
            if (payload?.price_on_call) {
              payload.discount_amount = null;
              payload.ad_price = null;
              payload.has_discount = false;
            }

            actionFn(payload);
          }}
        >
          {({setFieldValue, values, errors, isValid, submitCount}) => {
            return (
              <Form className="flex overflow-y-auto relative flex-col w-full h-full">
                <ScrollToError errors={errors} submitCount={submitCount} />

                <div className="flex flex-col px-3 py-3 w-full h-full">
                  <section>
                    <FloatingOnlySelectBottomSheet
                      value={state?.ad_type?.title}
                      wrapperClass="text-gray-500"
                      title="نوع آگهی"
                      disabled={true}
                    />
                    <p className="mt-3 text-md">
                      یکی از انواع آگهی را انتخاب کنید.
                    </p>
                    <div className="grid grid-cols-2 gap-2">
                      {adsTypes?.map((item: ISrs_type, index) => (
                        <PrimaryCardAR
                          key={item.id ?? index}
                          title={item.title}
                          image={item.image}
                          active={item.title === state.srs_type?.title}
                          disabled={item.type !== state?.srs_type?.type}
                        />
                      ))}
                    </div>
                  </section>
                  {state.srs_type?.type === 'sale' && (
                    <Sale
                      storePlanType={storePlanType}
                      srs_type={state.srs_type}
                      setOpenInputListBottomSheet={setOpenInputListBottomSheet}
                      setModalText={setModalText}
                      isLoading={
                        (state?.input_group &&
                          state?.input_group.type &&
                          dynamicLoadingState[state?.input_group.type]) ||
                        false
                      }
                      setIsEmptyFarmModal={setIsEmptyFarmModal}
                      rejection_reason={advertisementDetail?.rejection_reason}
                      unitData={unitData}
                    />
                  )}
                  {state.srs_type?.type === 'buy' && (
                    <Buy
                      srs_type={state.srs_type}
                      setOpenInputListBottomSheet={setOpenInputListBottomSheet}
                      setModalText={setModalText}
                      rejection_reason={advertisementDetail?.rejection_reason}
                      unitData={unitData}
                    />
                  )}
                  {state.srs_type?.type === 'rent' &&
                    advertisementDetail.input_group?.guid && (
                      <Rent
                        srs_type={state.srs_type}
                        setOpenInputListBottomSheet={
                          setOpenInputListBottomSheet
                        }
                        setModalText={setModalText}
                        rejection_reason={advertisementDetail?.rejection_reason}
                        unitData={unitData}
                      />
                    )}
                  {state.srs_type?.type === 'service' && (
                    <Service
                      srs_type={state.srs_type}
                      setOpenInputListBottomSheet={setOpenInputListBottomSheet}
                      setModalText={setModalText}
                      rejection_reason={advertisementDetail?.rejection_reason}
                      unitData={unitData}
                    />
                  )}
                </div>

                <InputListBottomsheet
                  {...{
                    openInputListBottomSheet,
                    setOpenInputListBottomSheet,
                  }}
                  srs_type={state?.srs_type}
                />

                {state?.ad_type?.value !== 'store' &&
                  openRentBottomsheet === true && (
                    <RentBottomsheet
                      {...{
                        openRentBottomsheet,
                        setOpenRentBottomsheet,
                      }}
                    />
                  )}
                {state?.ad_type?.value !== 'store' &&
                  openServiceBottomsheet === true && (
                    <ServiceBottomsheet
                      {...{
                        openServiceBottomsheet,
                        setOpenServiceBottomsheet,
                      }}
                    />
                  )}

                <AdvertisementTypesBottomSheet
                  {...{
                    openAdvertisementTypeBottomSheet,
                    setOpenAdvertisementTypeBottomSheet,
                  }}
                />
              </Form>
            );
          }}
        </Formik>
      ) : (
        <div className="flex flex-col justify-center items-center h-full">
          <DotsLoading />
        </div>
      )}
      <MainFooter />
      <SuccessRegisterModal
        {...{isSuccessModal, setIsSuccessModal, modalText, guid}}
      />
      <EmptyFarmModal {...{isEmptyFarmModal, setIsEmptyFarmModal}} />
    </div>
  );
};

export default EditAdds;
